import { SubAgentToolModel } from './sub-agent-tool.model';

/**
 * Extended SubAgentToolModel for the v2 chat renderer.
 * Adds watchables for tracking hijacked tool parts that need approval.
 */
export class SubAgentChatModel extends SubAgentToolModel {
  /**
   * Get the current count of tools needing approval
   */
  getPendingApprovalCount(): number {
    const parts = this.messagesWatchable.snapshot();
    return parts.filter(
      (m) =>
        m.isAssistantMessage() &&
        m.parts?.some(
          (p) =>
            p.isToolPart?.() &&
            p.isIncomplete?.() &&
            p.approvalStatus?.() === 'required'
        )
    ).length;
  }

  /**
   * Check if any tool in this sub-agent (or its nested sub-agents) needs approval
   */
  hasToolsNeedingApproval(): boolean {
    return this.getPendingApprovalCount() > 0;
  }
}
